import { render, staticRenderFns } from "./polygonTip.vue?vue&type=template&id=8a4fe308&scoped=true&"
import script from "./polygonTip.vue?vue&type=script&lang=js&"
export * from "./polygonTip.vue?vue&type=script&lang=js&"
import style0 from "./polygonTip.vue?vue&type=style&index=0&id=8a4fe308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4fe308",
  null
  
)

export default component.exports